import './CalendarDateCardComponent.scss';
import { useEffect, useState, useRef } from "react";
import moment from "moment";

interface CalendarCardComponentProps {
    appointments: Record<string, number>;
    onDateChange: (date: string) => void;
}

const CalendarDateCardComponent = (props: CalendarCardComponentProps) => {
    const { appointments, onDateChange } = props;
    const [dates, setDates] = useState<any>([]);
    const [selectedDate, setSelectedDate] = useState<string>("");
    const isFirstRender = useRef(true);

    useEffect(() => {
        const today = moment();
        const upcomingDates = Array.from({ length: 7 }, (_, i) => {
            const date = today.clone().add(i, 'days');
            const formattedDate = date.format("YYYY-MM-DD");

            return {
                date: formattedDate,
                isAppointmentPresent: appointments[formattedDate] > 0,
            };
        });

        setDates(upcomingDates);
        setSelectedDate(upcomingDates[0].date);

        // Prevent repeated API calls after first render
        if (isFirstRender.current) {
            onDateChange(upcomingDates[0].date);
            isFirstRender.current = false;
        }
    }, [appointments, onDateChange]);

    const handleDateClick = (date: string) => {
        setSelectedDate(date);
        onDateChange(date);
    };

    return (
        <div className={'calendar-card'}>
            <div className="date-selector">
                {dates.map((item: any, index: number) => (
                    <button
                        key={index}
                        className={`date-button ${item.date === selectedDate ? "active" : ""}`}
                        onClick={() => handleDateClick(item.date)}
                    >
                        <span className="day">{moment(item.date).format("ddd")}</span>
                        <span className="date-number">{moment(item.date).format("D")}</span>
                        {item.isAppointmentPresent && <span className="dot"></span>}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CalendarDateCardComponent;
